import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsHiddenUnansweredFieldsSvg = lazy(
  () => import('./svg-components/digital-forms-hidden-unanswered-fields-svg')
);

const DigitalFormsHiddenUnansweredFieldsSvg = ({
  assetsFallbackProps = {},
  customFallback,
  ...rest
}: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsHiddenUnansweredFieldsSvg {...rest} />
  </Suspense>
);

export default DigitalFormsHiddenUnansweredFieldsSvg;
